	/**
	* Returns a formatted date string, considering null or empty values.
	* @param {?} value - Any nullable value.
	* @param {boolean} includeTime - TRUE if the time is included, FALSE otherwise.
	* @param {boolean} dashIfEmpty - TRUE if an empty time returns a dash, FALSE if an empty item remains blank.
	* @returns {string} A string formatted date, or a string based upon dashIfEmpty.
	*/
export function formatDate(value, includeTime = false, dashIfEmpty = true) {
	if ((value) && ((typeof (value) === "number") || ((value !== "null") && (value.trim().length)))) {
		let d = new Date(value);
		if (includeTime) {
			return d.toLocaleString('en-GB').replace(/\u200E/g, "");
		}
		else {
			return d.toLocaleDateString('en-GB').replace(/\u200E/g, "");
		}
	}
	return (dashIfEmpty) ? "-" : "";
}